import { formatCurrency } from '../utils';
export function maskCurrency(value) {
    const numbers = value.replace(/\D/g, '');
    if (!numbers)
        return '';
    const numberValue = parseInt(numbers, 10) / 100;
    return formatCurrency(numberValue);
}
